import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-ink-900 text-white relative overflow-hidden" data-id="element-56">
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-brand-500/20 rounded-full blur-3xl pointer-events-none" data-id="element-57"></div>
      <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] bg-brand-500/15 rounded-full blur-3xl pointer-events-none" data-id="element-58"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-60">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500/10 text-brand-400 font-bold text-xs uppercase tracking-wider mb-6 border border-brand-500/20" data-id="element-61">
            Decisión final
          </div>

          <h2 className="text-4xl md:text-6xl font-extrabold mb-8 leading-[1.05] tracking-tight" data-id="element-62">
            El próximo domingo,{' '}
            <span className="text-brand-500" data-id="element-63">¿qué elegís?</span>
          </h2>

          <div className="space-y-5 text-lg md:text-xl text-ink-300 mb-12 leading-relaxed" data-id="element-64">
            <p data-id="element-65">
              Podés seguir buscando ejercicios sueltos a último momento,
              llegando a la cancha con la planificación a medio hacer...
            </p>
            <p className="font-bold text-brand-400 text-2xl md:text-3xl" data-id="element-66">
              O podés tener TODA tu temporada resuelta.
            </p>
            <p className="font-extrabold text-white text-2xl md:text-3xl pt-2" data-id="element-67">
              Dejá de improvisar.
            </p>
          </div>

          <button onClick={scrollToPricing} className="group w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white text-xl font-black py-5 px-10 rounded-2xl shadow-cta hover:shadow-2xl transition-all transform hover:-translate-y-0.5 mb-6 inline-flex items-center justify-center gap-3" data-id="element-68">
            QUIERO MI MEGA PACK
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-69" />
          </button>

          <div className="flex items-center justify-center gap-2 text-sm text-ink-400 font-medium" data-id="element-70">
            <Lock className="w-4 h-4" data-id="element-71" />
            Pago 100% seguro · Mercado Pago · Tarjeta · Transferencia
          </div>
        </motion.div>
      </div>
    </section>;
}